import React, { useEffect, useState } from "react";
import TableCustom from "../../../../components/table/tableCustom";
import TableRowCommon from "../../../../components/table/TableRowCommon";
import { NavigateFunction, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { dateTimeToView } from "../../../../utils/date.utils";
import { routeName } from "../../../../routes/routeName";
import { icons } from "../../../../assets/icons/icons";
import { advisorApi } from "../../../../api/advisor/advisor.api";
import CustomStatus from "../../../../components/chip/CustomStatus";
import {
  handleColorStatusConsultRequestUtil,
  handleTextStatusConsultRequestUtil,
} from "../../../../utils/statusRequest";
import { FiberManualRecord } from "@mui/icons-material";

interface ListConsultRequestProps {
  search: string;
  page: number;
  setPage: React.Dispatch<React.SetStateAction<number>>;
  totalItems: number;
  setTotalItems: React.Dispatch<React.SetStateAction<number>>;
  sortBy: string;
  sortType: string;
  pageLimit: number;
  setPageLimit: React.Dispatch<React.SetStateAction<number>>;
  startDate: any;
  endDate: any;
  inputValueSearch: any;
  tabStep: number;
}

const ListConsultationRequest: React.FC<ListConsultRequestProps> = ({
  search,
  page,
  setPage,
  totalItems,
  setTotalItems,
  sortBy,
  sortType,
  pageLimit,
  setPageLimit,
  startDate,
  endDate,
  inputValueSearch,
  tabStep,
}) => {
  const navigate: NavigateFunction = useNavigate();
  const dispatch = useDispatch();

  const { profile } = useSelector((state: any) => state.profile);

  const [dataAdvisorRequestConsultaion, setDataAdvisorRequestConsultaion] =
    useState<any>([]);

  const headCells = [
    {
      id: "fullname",
      width: 50,
      disablePadding: true,
      align: "start",
      label: "ชื่อ - นามสกุล",
    },
    {
      id: "nickname",
      disablePadding: true,
      width: 15,
      align: "start",
      label: "ฉายา",
    },
    {
      id: "student_no",
      disablePadding: false,
      align: "center",
      width: 15,
      label: "รหัสประจำตัวนักศึกษา",
    },
    {
      id: "consultation_name",
      disablePadding: false,
      align: "center",
      width: 15,
      label: "เรื่องที่ขอคำปรึกษา",
    },
    {
      id: "consultation_group",
      disablePadding: false,
      align: "center",
      width: 15,
      label: "ประเภทขอคำปรึกษา",
    },
    {
      id: "date_request",
      disablePadding: false,
      align: "center",
      width: 20,
      label: "วันที่ขอคำปรึกษา",
    },
    {
      id: "status",
      disablePadding: false,
      align: "center",
      width: 20,
      label: "สถานะ",
    },
    {
      id: "action",
      disablePadding: false,
      align: "center",
      width: 20,
      label: "action",
    },
  ];

  const renderData = (objData: any, no: any) => {
    no = page * pageLimit - pageLimit + no + 1;
    const {
      id_advisor_student,
      student_frist_name,
      student_last_name,
      student_nickname,
      student_no,
      consultation_name,
      created_date,
      status,
      status_request,
      grade_level,
      faculty_name,
      advisor_student_detaill,
    } = objData;

    let parsedAdvisorStudentDetail = [];

    try {
      parsedAdvisorStudentDetail = JSON.parse(advisor_student_detaill);
    } catch (error) {
      console.error("Error parsing advisor_student_detaill:", error);
    }

    const objRenderData = {
      key: id_advisor_student,
      id: no,
      obj: objData,
      columns: [
        {
          option: "TEXT",
          align: "start",
          label: student_frist_name + " " + student_last_name,
        },
        {
          option: "TEXT",
          align: "start",
          label: student_nickname,
        },
        {
          option: "TEXT",
          align: "center",
          label: student_no,
        },
        {
          option: "TEXT",
          align: "center",
          disablePadding: true,
          label: parsedAdvisorStudentDetail?.advisor_type_name ?? "",
        },
        {
          option: "TEXT",
          align: "center",
          disablePadding: true,
          label: parsedAdvisorStudentDetail?.advisor_group ?? "",
        },
        {
          option: "TEXT",
          align: "center",
          disablePadding: true,
          label: created_date ? dateTimeToView(created_date) : "",
        },
        {
          option: "TEXT",
          align: "center",
          // label: status,
          label: (
            <CustomStatus
              label={handleColorStatusConsultRequestUtil(
                parsedAdvisorStudentDetail?.status,
                profile && profile.user_type
              )}
              type="outlined"
              color={handleTextStatusConsultRequestUtil(
                parsedAdvisorStudentDetail?.status
              )}
              icon={<FiberManualRecord />}
              width="250px"
            />
          ),
        },
        {
          option: "TEXT",
          align: "center",
          label: (
            <div
              style={{
                display: "flex",
                textAlign: "center",
                justifyContent: "center",
              }}
            >
              <img
                onClick={() => {
                  navigate(
                    routeName.advisor.studentConsultation +
                      `/${id_advisor_student}?grade_level=${grade_level}&faculty_name=${faculty_name}`
                  );
                }}
                src={icons.eye}
                alt="eye"
                style={{ cursor: "pointer" }}
              />
            </div>
          ),
        },
      ],
    };
    return <TableRowCommon {...objRenderData} />;
  };

  const fetchGetRequestConsultationAdvisorStudent = async () => {
    let query: any = {
      page: page,
      limit: pageLimit,
      sdate: startDate,
      edate: endDate,
      status: inputValueSearch?.status,
      advisorTypeId:
        inputValueSearch.consultation_type === "ทุกเรื่องที่ขอคำปรึกษา"
          ? ""
          : inputValueSearch.consultation_type,
    };

    if (search) query = { ...query, search: search };

    const res = await advisorApi.getRequestConsultationAdvisorStudent(query);
    const data = res.data;
    if (data.status < 300) {
      setDataAdvisorRequestConsultaion(data.data?.advisor_request?.items ?? []);
      setTotalItems(data.data?.advisor_request?.meta?.totalItems ?? 0);
    } else {
      setDataAdvisorRequestConsultaion([]);
    }
  };

  useEffect(() => {
    if (tabStep === 1) {
      fetchGetRequestConsultationAdvisorStudent();
    }
  }, [
    page,
    pageLimit,
    sortBy,
    sortType,
    search,
    totalItems,
    inputValueSearch,
    startDate,
    endDate,
    tabStep,
  ]);

  return (
    <section className="w-full mt-10">
      <TableCustom
        tableMinWidth={2000}
        tableFixedWidth
        customScroll
        page={page}
        pageLimit={pageLimit}
        sortBy={sortBy}
        sortType={sortType}
        headCells={headCells}
        rowCount={totalItems}
        rowsData={
          dataAdvisorRequestConsultaion &&
          dataAdvisorRequestConsultaion.map((data: any, i: any) => {
            return renderData(data, i);
          })
        }
        onSort={() => {}}
        setPageLimit={(value: number) => setPageLimit(value)}
        setPage={(value: number) => setPage(value)}
      />
    </section>
  );
};

export default ListConsultationRequest;
